import { render, staticRenderFns } from "./popup-open-bao-xiao.vue?vue&type=template&id=82e342ca&scoped=true"
import script from "./popup-open-bao-xiao.vue?vue&type=script&lang=js"
export * from "./popup-open-bao-xiao.vue?vue&type=script&lang=js"
import style0 from "./popup-open-bao-xiao.vue?vue&type=style&index=0&id=82e342ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e342ca",
  null
  
)

export default component.exports